import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ServiceBase } from "./servicebase";
import { SessionService } from "./sessionservice";

@Injectable()
export class DashboardService extends ServiceBase {
  
  constructor(private http: HttpClient, private sessionService:SessionService) {
    super();
  }

  getDashboardStats() {
    const params = new HttpParams()
                        .set('userId', this.sessionService.userId)
                        .set('userOrg', this.sessionService.userOrg);
    return this.http.get(this.apiBaseUrl + 'dashboard', {params});
  }
}
